import React from 'react';
import { Fade } from '../deck/Slide';
const nextSteps = ['Agree the Q4 pilot scope', 'Lock brands, markets and campaigns', 'Go live and report from one viewpane'];
export function ClosingSlide() {
  return <div className="relative h-full w-full overflow-hidden bg-black font-sans" data-id="element-25" data-mp="22m151hrdrtmh">
      <div className="absolute inset-0" data-id="element-26" data-mp="27jjdl71hk6ty">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/54075cb1-fb1b-4072-b380-f0f0d7725f8d.jpg" alt="Healthcare professional viewing short-form video content on a phone in a clinic" className="h-full w-full object-cover" data-id="element-27" data-mp="27kcg1vtewa6a" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/30" data-id="element-28" data-mp="2laoai1dgyl0l" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-black/40" data-id="element-29" data-mp="2q9995wd2owmx" />
      </div>

      <div className="absolute left-0 right-0 top-0 z-20 h-1 bg-[var(--brand-green)]" data-id="element-30" data-mp="19uzl73cqt9wm" />

      <div className="relative z-10 flex h-full flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(4rem,8vh,6rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-31" data-mp="1ewyq4ho4sevo">
        <div className="max-w-4xl" data-id="element-32" data-mp="3tt6wgxx0d7v6">
          <div className="mb-[clamp(1.25rem,2.5vw,2rem)] flex items-center gap-4" data-id="element-33" data-mp="3tu8ifxfkbero">
            <span className="h-px w-10 bg-[var(--brand-green-lighter)]" data-id="element-34" data-mp="bnkck5counky" />
            <p className="text-[clamp(0.85rem,1.3vw,1.1rem)] font-semibold uppercase tracking-[0.25em] text-[var(--brand-green-lighter)]" data-id="element-35" data-mp="6oh9gqg9qrfm">
              Next step
            </p>
          </div>

          <h2 className="text-[clamp(2.5rem,6vw,5.5rem)] font-bold leading-[1] tracking-tight text-white" data-id="element-36" data-mp="gmeznjhouyav">
            Prove it in Q4.
            <br data-id="element-37" data-mp="ucqqlf2jer0f" />
            <span className="text-[var(--brand-green-lighter)]" data-id="element-38" data-mp="udaa307u5ngk">
              Scale it in 2027.
            </span>
          </h2>

          <Fade delay={0.15} data-id="element-39" data-mp="qekoikcn8zlu">
            <p className="mt-[clamp(1.25rem,2.5vw,2rem)] max-w-2xl text-[clamp(1rem,1.6vw,1.4rem)] font-medium leading-snug text-white/85" data-id="element-40" data-mp="14bg6516ynzdi">
              Pick the pilot scope that fits this year&rsquo;s budget. We build
              the central foundation once, and every market inherits it.
            </p>
          </Fade>

          <Fade delay={0.3} data-id="element-41" data-mp="11vf97iq4p84">
            <div className="mt-[clamp(1.5rem,3vw,2.5rem)] flex flex-wrap gap-3" data-id="element-42" data-mp="yzi3lepa4kq">
              {nextSteps.map(step => <span key={step} className="rounded-full border border-white/15 bg-white/[0.07] px-[clamp(0.9rem,1.6vw,1.5rem)] py-[clamp(0.55rem,1vw,0.9rem)] text-[clamp(0.8rem,1.1vw,1rem)] font-semibold text-white backdrop-blur-md" data-id="element-43" data-mp="aqlon4g3ffh5">
                  {step}
                </span>)}
            </div>
          </Fade>
        </div>
      </div>

      <div className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 hidden md:block" data-id="element-44" data-mp="tq9c3jy2tfi3">
        <p className="max-w-xl border-l-2 border-[var(--brand-green)] pl-4 text-[clamp(0.95rem,1.4vw,1.2rem)] font-medium text-white/70" data-id="element-45" data-mp="2qjudehq1ecu4">
          Snakker &times; LEO Pharma
        </p>
      </div>
    </div>;
}